import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import config from 'utils/config';

// Checks if the user is a Helix user based on the helixIntegrationMode
// and whether the user is member of a team with a helix role teamtype
export function checkIsHelixUser(teamsWithTeamTypes) {
  if (config.helixIntegrationMode === 'helix') {
    return true;
  }
  if (config.helixIntegrationMode === 'both') {
    if (!(teamsWithTeamTypes !== null && teamsWithTeamTypes !== void 0 && teamsWithTeamTypes.length)) {
      return false;
    }
    var teamTypeRoles = teamsWithTeamTypes.map(function (team) {
      return team.teamType.role;
    }).filter(Boolean);
    if (teamTypeRoles.includes('helix')) {
      return true;
    }
  }
  return false;
}